import PropTypes from 'prop-types';
import React from 'react';

const IconSubMerchantActivation = ({ className }) => {
  return (
    <svg
      className={className}
      fill="currentColor"
      height="30"
      viewBox="0 0 30 30"
      width="30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.6922 10.8533L28.2922 5.02667C27.9989 3.82667 26.9589 3 25.7455 3H22.7989H20.1189H17.8255H15.1589H12.8655H10.1722H7.22553C6.02553 3 4.9722 3.84 4.6922 5.02667L3.2922 10.8533C2.9722 12.2133 3.26553 13.6 4.11886 14.6933C4.22553 14.84 4.3722 14.9467 4.4922 15.08V24.3333C4.4922 25.8 5.6922 27 7.15886 27H25.8255C27.2922 27 28.4922 25.8 28.4922 24.3333V15.08C28.6122 14.96 28.7589 14.84 28.8655 14.7067C29.7189 13.6133 30.0255 12.2133 29.6922 10.8533ZM9.8522 5.66667L9.07886 12.1467C8.9722 13.0133 8.27886 13.6667 7.46553 13.6667C6.8122 13.6667 6.39886 13.28 6.22553 13.04C5.87886 12.6 5.75886 12.0267 5.8922 11.48L7.22553 5.66667H9.8522ZM25.7055 5.65333L27.1055 11.48C27.2389 12.04 27.1189 12.6 26.7722 13.04C26.5855 13.28 26.1855 13.6667 25.5189 13.6667C24.7055 13.6667 23.9989 13.0133 23.9055 12.1467L23.1322 5.66667L25.7055 5.65333ZM21.1722 11.6933C21.2389 12.2133 21.0789 12.7333 20.7322 13.12C20.4255 13.4667 19.9989 13.6667 19.4522 13.6667C18.5589 13.6667 17.8255 12.88 17.8255 11.92V5.66667H20.4389L21.1722 11.6933ZM15.1589 11.92C15.1589 12.88 14.4255 13.6667 13.4389 13.6667C12.9855 13.6667 12.5722 13.4667 12.2522 13.12C11.9189 12.7333 11.7589 12.2133 11.8122 11.6933L12.5455 5.66667H15.1589V11.92ZM24.4922 24.3333H8.4922C7.75886 24.3333 7.15886 23.7333 7.15886 23V16.2933C7.26553 16.3067 7.35886 16.3333 7.46553 16.3333C8.62553 16.3333 9.67886 15.8533 10.4522 15.0667C11.2522 15.8667 12.3189 16.3333 13.5322 16.3333C14.6922 16.3333 15.7322 15.8533 16.5055 15.0933C17.2922 15.8533 18.3589 16.3333 19.5589 16.3333C20.6789 16.3333 21.7455 15.8667 22.5455 15.0667C23.3189 15.8533 24.3722 16.3333 25.5322 16.3333C25.6389 16.3333 25.7322 16.3067 25.8389 16.2933V23C25.8255 23.7333 25.2255 24.3333 24.4922 24.3333Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconSubMerchantActivation;

IconSubMerchantActivation.propTypes = {
  className: PropTypes.string,
};
